import { render, staticRenderFns } from "./ModalChiefIntro.vue?vue&type=template&id=49042489&scoped=true&"
import script from "./ModalChiefIntro.vue?vue&type=script&lang=js&"
export * from "./ModalChiefIntro.vue?vue&type=script&lang=js&"
import style0 from "./ModalChiefIntro.vue?vue&type=style&index=0&id=49042489&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49042489",
  null
  
)

export default component.exports